// The forms and password disclosure are server-rendered; this only adds convenience.
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  document.querySelectorAll('.db-access__disclosure[open]').forEach((details) => {
    if (event.target.closest('.db-access__close') || !details.contains(event.target)) {
      details.open = false;
      if (event.target.closest('.db-access__close')) details.querySelector('summary')?.focus();
    }
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.db-access__disclosure[open]').forEach((details) => {
    details.open = false;
    details.querySelector('summary')?.focus();
  });
});

function enhancePasswordPage() {
  document.querySelectorAll('.db-access__close').forEach((button) => { button.hidden = false; });
  document.querySelector('[data-signup-result]')?.focus({ preventScroll: true });
}

enhancePasswordPage();
document.addEventListener('shopify:section:load', enhancePasswordPage);
